import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import asRendition from '../../../asRendition';
import { px } from '../../../utils';
export var LegendElement = styled.legend(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-size: ", ";\n\tcolor: #252629;\n\tmargin-top: 16px;\n\tmargin-bottom: 8px;\n\twidth: 100%;\n"], ["\n\tfont-size: ", ";\n\tcolor: #252629;\n\tmargin-top: 16px;\n\tmargin-bottom: 8px;\n\twidth: 100%;\n"])), function (props) { return px(props.theme.fontSizes[2]); });
var TitleFieldBase = function (props) {
    var id = props.id, required = props.required, title = props.title, theme = props.theme;
    if (!title) {
        return null;
    }
    return (React.createElement(LegendElement, { id: id, theme: theme },
        title,
        required && '*'));
};
export var TitleField = asRendition(TitleFieldBase);
var templateObject_1;
